var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('common-calendar',{ref:"calendar",attrs:{"filterObj":_vm.filters,"api":_vm.apiCall,"calendarOption":_vm.calendarOptions,"classes":'fullcalendar-header-style-lg',"onEventClick":_vm.handleEventClick,"setEventsandUsers":_vm.setEventsandUsers,"filters":{ setCustomButtons: true }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }